import { useMedia } from 'react-use';

export const useOrientation = () => {
    const isLandscape = useMedia('(orientation: landscape)');
    const isPortrait = useMedia('(orientation: portrait)');

    return { isLandscape, isPortrait };
};
